import React from "react";
import style from "./index.module.scss";
import { Alert, Button, Icon, Tooltip } from "antd";
import className from "classnames";
import { useAtomValue } from "jotai";
import { disabledAtom } from "../../store";
import { useParams } from "react-router-dom";

interface Iprops {
    count: number; //当前权重总和
    onAdd: () => void; //添加行
    percent: number; //成绩占比
    ruleCourseName: string; //考核名称
}

const Index = ({ count, onAdd, percent, ruleCourseName }: Iprops) => {
    const { courseNo, courseSeq } = useParams<StringMap>();

    const disabled = useAtomValue(disabledAtom({ courseNo, courseSeq }));

    const tooltipTitle = (
        <div className={style.toolTip}>
            <div className={style.tTitle}>何时需要设置自定义考核？</div>
            <div className={style.tContent}>
                1.内置的考核项无法满足教师的考核需求时。
                <br />
                2.线下开展教学活动的考核项。
                <br />
                3.在第三方平台开展的教学活动的考核项。
            </div>
        </div>
    );

    return (
        <div className={style.root}>
            <div className={style.left}>
                当前小计：
                <b
                    className={className({
                        [style.error]: percent !== count,
                        [style.success]: percent === count
                    })}>
                    {count}%
                </b>
                {percent !== count && (
                    <Alert
                        message={`由于${ruleCourseName}占比为${percent}%，所以权重总和必须等于${percent}%，否则无法保存`}
                        type="warning"
                        showIcon
                    />
                )}
            </div>
            <div className={style.right}>
                <Button
                    type="primary"
                    ghost
                    onClick={onAdd}
                    disabled={disabled}>
                    {!disabled && (
                        <img
                            src={require("./image/icon.png")}
                            alt=""
                            className={style.img}
                        />
                    )}
                    新增自定义考核项
                </Button>
                <Tooltip placement="topLeft" title={tooltipTitle}>
                    <Icon type="exclamation-circle" />
                </Tooltip>
            </div>
        </div>
    );
};

export default Index;
